import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import { ToastContainer } from '@rewardopl/react-toast';

import colors from '@rewardopl/styles/colors';

import { GlobalStyle } from './root.styles';

import AuthGate from './auth_gate';
import ErrorBoundary from './error_boundary';
import OnlineMonitor from './online_monitor';
import AuthCallback from './pages/auth/callback';
import ErrorPage from './pages/error';
import IndexPage from './pages/index/index';
import LoginPage from './pages/login';
import OfflinePage from './pages/offline';
import OnboardingPage from './pages/onboarding';
import PasswordResetPage from './pages/password_reset';
import PasswordResetConfirmationPage from './pages/password_reset_confirmation';
import RegisterPage from './pages/register';
import UnlockPage from './pages/unlock';
import VerifyPage from './pages/verify';
import PushHandler from './push_handler';
import SplashScreen from './splash_screen';

import { isLoggedIn, isLoggedOut } from '../helpers/authorization';

export default function Root() {
  return (
    <>
      <GlobalStyle />
      <Routes>
        <Route path="camera" />
        <Route element={<meta content={colors.background} name="theme-color" />} path="*" />
      </Routes>
      <ToastContainer position="top-right" />
      <Suspense fallback={null}>
        <PushHandler />
      </Suspense>
      <ErrorBoundary fallback={<ErrorPage />}>
        <OnlineMonitor fallback={<OfflinePage />}>
          <Suspense fallback={<SplashScreen />}>
            <Routes>
              <Route
                element={
                  <AuthGate anyOf={isLoggedOut}>
                    <AuthCallback />
                  </AuthGate>
                }
                path="auth/:provider/callback"
              />
              <Route
                element={
                  <AuthGate anyOf={isLoggedOut}>
                    <LoginPage />
                  </AuthGate>
                }
                path="login/*"
              />
              <Route
                element={
                  <AuthGate anyOf={isLoggedOut}>
                    <PasswordResetPage />
                  </AuthGate>
                }
                path="password_reset"
              />
              <Route
                element={
                  <AuthGate anyOf={isLoggedOut}>
                    <PasswordResetConfirmationPage />
                  </AuthGate>
                }
                path="password_reset_confirmation"
              />
              <Route
                element={
                  <AuthGate anyOf={isLoggedOut}>
                    <RegisterPage />
                  </AuthGate>
                }
                path="register"
              />
              <Route
                element={
                  <AuthGate anyOf={isLoggedOut}>
                    <UnlockPage />
                  </AuthGate>
                }
                path="unlock"
              />
              <Route element={<VerifyPage />} path="verify" />
              <Route
                element={
                  <AuthGate anyOf={isLoggedOut}>
                    <OnboardingPage />
                  </AuthGate>
                }
                path="onboarding"
              />
              <Route
                element={
                  <AuthGate anyOf={isLoggedIn}>
                    <IndexPage />
                  </AuthGate>
                }
                path="*"
              />
            </Routes>
          </Suspense>
        </OnlineMonitor>
      </ErrorBoundary>
    </>
  );
}
